module.exports = __webpack_public_path__ + "static/media/Upload-link.667da107.svg";